<div data-test="a1Bf9ZcT" class="filters-h__item" (mdOutsideClick)="hideFilterOptions()">
  <div data-test="dQqhFGw3" class="button button_filter button_sm button_secondary">
    <div data-test="ZZFW2KUb" class="button__filter-container">
      <div
        data-test="fBZeO0ZR"
        (click)="toggleFilterOptionsVisibility()"
        class="button__filter-selected button__filter-selected_static"
      >
        <input data-test="ogch6Q_9" class="button__filter-input" type="hidden" value="" />
        <div data-test="sW5NHE1c" class="button__filter-selected-text">
          <b data-test="mZIQqkDC">{{ filter.label }}</b>
        </div>
      </div>
      <div data-test="0Ih2ZrTa" class="button__filter-append">
        <button
          data-test="tO-viPyT"
          (click)="onResetFilter(filter)"
          class="button__filter-icon"
        >
          <svg data-test="NwERHHYb" class="icon__icon-refresh" width="10px" height="11px">
            <use xlink:href="#icon-refresh"></use>
          </svg>
        </button>
        <button
          data-test="QT_n02mc"
          (click)="onRemoveFilter(filter)"
          class="button__filter-icon"
        >
          <svg data-test="r4TiO7eI" class="icon__clear" width="10px" height="9px">
            <use xlink:href="#clear"></use>
          </svg>
        </button>
      </div>
    </div>
  </div>
  <div
    data-test="x1zjw0WQ"
    *ngIf="filterOptionsVisible"
    class="dropdown dropdown_bottom-middle dropdown_arrow dropdown_filter dropdown_static show active"
  >
    <div data-test="TTYPcT-2" class="dropdown__wrap">
      <div
        data-test="2gELJiPy"
        *ngIf="filter.hasSearch"
        class="dropdown__search dropdown__search_prepend"
      >
        <div data-test="k2T9PACh" class="dropdown__search-prepend">
          <div data-test="n0Mjnx0a" class="icon">
            <svg
              data-test="1AASuAyr"
              class="icon__icon-search"
              width="18px"
              height="17.5px"
            >
              <use xlink:href="#icon-search"></use>
            </svg>
          </div>
        </div>
        <input
          data-test="TfzOUGbl"
          #searchInput
          (keyup)="onSearchFilterOptions(searchInput.value, filter)"
          class="dropdown__input input input_xs"
          placeholder="Search ..."
          value=""
          type="text"
        />
      </div>
      <ng-container *ngIf="filter.isRangeFilter; else filterOptions">
        <div data-test="-DWtASvj" class="row m-0 py-2" [formGroup]="rangeSliderFormGroup">
          <div data-test="YURVI7lk" class="col-6">
            <input
              data-test="OAYB6dvE"
              formControlName="from"
              class="input input_xs px-0 text-center"
              type="number"
              min="0"
              [max]="rangeSliderFormGroup.value.to"
              style="width: 60px"
            />
          </div>
          <div data-test="n4Y_TrFL" class="col-6 text-right">
            <input
              data-test="rFuzy--V"
              formControlName="to"
              class="input input_xs px-0 text-center"
              type="number"
              min="0"
              [max]="getRange(filter).to"
              style="width: 60px"
            />
          </div>
          <div data-test="dIHls1xy" class="col-12">
            <ngx-slider
              data-test="_IUyxsZ-"
              (userChange)="onRangeSliderChange($event)"
              [value]="rangeSliderFormGroup.value.from"
              [highValue]="rangeSliderFormGroup.value.to"
              [options]="rangeSliderOptions"
            ></ngx-slider>
          </div>
        </div>
      </ng-container>
      <ng-template #filterOptions>
        <ul data-test="AXINcf_0" class="dropdown__menu" data-simplebar>
          <li
            data-test="8zZlKlWI"
            *ngFor="let filterOption of getOptions(filter); trackBy: trackControl"
            class="dropdown__menu-item"
          >
            <div data-test="DTlH5wZ0" class="dropdown__menu-link">
              <div data-test="LPzxnWFR" class="dropdown__menu-checkbox">
                <label data-test="dJsSUeKV" class="checkbox">
                  <input
                    data-test="RU6xtzzw"
                    (click)="onToggleFilterOption(filter.name, filterOption.name, $event)"
                    [checked]="filterOption.isActive"
                    type="checkbox"
                  />
                  <span data-test="AtlYVwN5" class="checkbox__marker">
                    <span data-test="CzCoFIR1" class="checkbox__marker-icon">
                      <svg
                        data-test="RVyP8oDU"
                        class="icon__icon-check"
                        width="9.07px"
                        height="6.95px"
                      >
                        <use xlink:href="#icon-check"></use>
                      </svg>
                    </span>
                  </span>
                  <span data-test="DHx5pcD2" class="checkbox__label">
                    {{ filterOption.label }}
                    <span data-test="TlAc0hCq" class="text-light">
                      ({{ filterOption.count }})
                    </span>
                  </span>
                </label>
              </div>
            </div>
          </li>
        </ul>
      </ng-template>
    </div>
  </div>
</div>
